var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 54,
    viewBox: "0 0 44 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2431 43.7111L38.3572 44.4218L38.3896 44.4623L41.0466 47.7745L13.2297 41.593V31.3248L7.80021 30.1183V30.9721V40.3864L28.3441 44.9517V26.9824L22.9146 25.7759V26.6298V43.7452L20.8263 43.2811V28.7346L15.3969 27.528V28.3819V42.0746L36.0736 46.6694V19.7155L30.6441 18.5089V19.3628V45.4629L5.59678 39.8968V3.58222L8.28621 6.9349L8.37114 6.86678L9.17213 6.22424L4.9703 0.986084L0.768473 4.35667L0.800998 4.39722L1.6544 5.46117L4.34383 3.30378V40.9019L41.0466 49.058L38.3572 51.2153L38.3897 51.2559L39.2431 52.3197L42.6439 49.5917L43.4449 48.9492L39.2431 43.7111ZM34.8207 46.3909L31.8971 45.7412V20.0708L34.8207 20.7205V46.3909ZM19.5734 43.0026L16.6498 42.3529V29.0899L19.5734 29.7396V43.0026ZM27.0911 44.6732L24.1675 44.0235V27.3378L27.0911 27.9874V44.6732ZM11.9767 41.3145L9.05316 40.6648V31.6801L11.9767 32.3298V41.3145Z",
    fill: "#4A0B82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9767 41.3145L9.05316 40.6648V31.6801L11.9767 32.3298V41.3145Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5734 43.0026L16.6498 42.3529V29.0899L19.5734 29.7396V43.0026Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0911 44.6732L24.1675 44.0235V27.3378L27.0911 27.9874V44.6732Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8207 46.3909L31.8971 45.7412V20.0708L34.8207 20.7205V46.3909Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4746 44.3942L38.3896 44.4623L37.5887 45.1049L40.2781 48.4576L12.4612 42.2761V32.0079L7.80021 30.9721L7.03173 30.8014V41.0695L27.5756 45.6348V27.6655L22.9146 26.6298L22.1461 26.459V44.4283L20.0579 43.9642V29.4176L15.3969 28.3819L14.6284 28.2111V42.7577L35.3052 47.3525V20.3986L30.6441 19.3628L29.8757 19.192V46.146L4.82831 40.5799V4.2653L7.51774 7.61799L8.40366 6.90733L8.37114 6.86678L4.20183 1.66917L0.800998 4.39722L0 5.03976L0.885924 6.14425L3.57535 3.98687V41.585L40.2781 49.7411L38.3897 51.2559L37.5887 51.8984L38.4746 53.0028L42.6764 49.6322L42.6439 49.5917L38.4746 44.3942ZM34.0522 47.074L31.1286 46.4243V20.7539L34.0522 21.4036V47.074ZM18.8049 43.6857L15.8813 43.036V29.773L18.8049 30.4226V43.6857ZM26.3226 45.3563L23.3991 44.7066V28.0209L26.3226 28.6705V45.3563ZM11.2083 41.9976L8.28469 41.3479V32.3632L11.2083 33.0129V41.9976Z",
    fill: "#4A0B82"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2083 41.9976L8.28469 41.3479V32.3632L11.2083 33.0129V41.9976Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8049 43.6857L15.8813 43.036V29.773L18.8049 30.4226V43.6857Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3226 45.3563L23.3991 44.7066V28.0209L26.3226 28.6705V45.3563Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0522 47.074L31.1286 46.4243V20.7539L34.0522 21.4036V47.074Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80021 30.9721V30.1183L7.03173 30.8014L7.80021 30.9721Z",
    fill: "#4A0B82"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0.800998 4.39722L0.768473 4.35667L0 5.03976L0.800998 4.39722Z",
    fill: "#4A0B82"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17213 6.22424L8.37114 6.86678L8.40366 6.90733L9.17213 6.22424Z",
    fill: "#4A0B82"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3969 28.3819V27.528L14.6284 28.2111L15.3969 28.3819Z",
    fill: "#4A0B82"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9146 26.6298V25.7759L22.1461 26.459L22.9146 26.6298Z",
    fill: "#4A0B82"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6441 19.3628V18.5089L29.8757 19.192L30.6441 19.3628Z",
    fill: "#4A0B82"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3896 44.4623L38.3572 44.4218L37.5887 45.1049L38.3896 44.4623Z",
    fill: "#4A0B82"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3897 51.2559L38.3572 51.2153L37.5887 51.8984L38.3897 51.2559Z",
    fill: "#4A0B82"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4449 48.9492L42.6439 49.5917L42.6764 49.6322L43.4449 48.9492Z",
    fill: "#4A0B82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard6);
export default __webpack_public_path__ + "static/media/card6.5790ac587e059f367eb23ab3201b96f9.svg";
export { ForwardRef as ReactComponent };